<template>
  <!-- 巡检维修-任务管理-查询列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-tabs default-active-key="全部"
              v-model="query.status"
              @change="callback">
        <a-tab-pane key=""
                    tab="全部"></a-tab-pane>
        <a-tab-pane :key="0"
                    tab="未开始"></a-tab-pane>
        <a-tab-pane :key="1"
                    tab="执行中"></a-tab-pane>
        <a-tab-pane :key="2"
                    tab="已提交"></a-tab-pane>
        <a-tab-pane :key="3"
                    tab="已完成"></a-tab-pane>
      </a-tabs>
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="任务编号">
              <a-input v-model="query.taskNumber"
                       placeholder="请输入任务编号"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="任务类型">
              <a-select placeholder="请选择任务类型"
                        v-model="query.taskType">
                <a-select-option v-for="item in TaskList"
                                 :key="item.dictValue">{{ item.dictValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="任务名称">
              <a-input v-model="query.taskName"
                       placeholder="请输入任务名称"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="负责人">
              <a-input v-model="query.principalName"
                       placeholder="请输入负责人"
                       allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="发生地点">
              <a-input v-model="query.address"
                       placeholder="请输入发生地点"
                       allow-clear />
            </a-form-item>
          </a-col>

          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="计划处理时长">
              <a-input v-model="query.processingTime" placeholder="请输入计划处理时长" allow-clear />
            </a-form-item>
          </a-col> -->
          <a-col :md="9"
                 :sm="10">
            <a-form-item label="计划开始时间">
              <a-range-picker @change="onChanget"
                              v-model="onChangets" />
            </a-form-item>
          </a-col>
          <a-col :md="9"
                 :sm="10">
            <a-form-item label="开始时间">
              <a-range-picker v-model="Uploadtime"
                              @change="onChanges" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="PublishTask()"
                        v-action:add>新增</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="exportHandle()"
                        v-action:export>导出</a-button>
              <a-button v-if="query.status === 3"
                        type="primary"
                        style="margin-left: 8px"
                        @click="DispatchOrder()"
                        v-action:rwzpfgd>派发工单</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()">删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             bordered
             :scroll="{ x: 2100 }"
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <span slot="action"
            slot-scope="text, record">
        <!-- <span v-if="record.status !== 2">
          <a v-if="query.status === '' || query.status === 0" @click="editHandle(record)">编辑</a>
        </span> -->

        <!-- <a-divider v-if="query.status === '' || query.status === 0" type="vertical" /> -->
        <a @click="goDetails(record.id)">详情</a>
      </span>
      <span slot="createTime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="predictStime"
            slot-scope="text"
            v-if="text !== null">{{ moment(text).format('YYYY-MM-DD') }} </span>
      <span slot="planTime"
            slot-scope="text"
            v-if="text !== null">{{ text }} 天</span>
      <span slot="processingTime"
            slot-scope="text"
            v-if="text !== null">{{ text }}</span>

      <template slot="statusAction"
                slot-scope="text">
        <a-tag color="rgb(255, 99, 71)"
               v-if="text == 0">未开始</a-tag>
        <a-tag color="#f98303"
               v-if="text == 1">执行中</a-tag>
        <a-tag color="#40a9ff"
               v-if="text == 2">已提交</a-tag>
        <a-tag color="rgb(50, 205, 50"
               v-if="text == 3">已完成</a-tag>
      </template>
    </a-table>
    <!-- <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    ></a-modal>-->

    <task-modal ref="TaskModal"
                @handleOk="queryList"></task-modal>
    <details-modal ref="DetailsModal"
                   @handleOk="queryList"></details-modal>
    <order-modal ref="OrderModal"
                 @handleOk="queryList"></order-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import TaskModal from './modules/TaskModal'
import DetailsModal from './modules/DetailsModal'
import OrderModal from './modules/OrderModal'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '任务编号',
    dataIndex: 'taskNumber',
    width: 150,
  },
  {
    title: '片区',
    dataIndex: 'zoneName',
  },

  {
    title: '任务类型',
    dataIndex: 'taskType',
  },
  {
    title: '任务名称',
    dataIndex: 'taskName',
  },
  {
    title: '发布人',
    dataIndex: 'publisherName',
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },
  // {
  //   title: '协办人',
  //   dataIndex: 'assistPersonName',
  // },
  {
    title: '计划开始时间',
    dataIndex: 'predictStime',
    scopedSlots: { customRender: 'predictStime' },
  },
  {
    title: '计划处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },
  {
    title: '发生地点',
    dataIndex: 'address',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
  },
  {
    title: '处理时长',
    dataIndex: 'processingTime',
    scopedSlots: { customRender: 'processingTime' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },

  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    TaskModal,
    DetailsModal,
    OrderModal,
  },
  name: 'TaskManagement',
  data () {
    return {
      currentId: '',
      queryUrl: '/pipe-network/inspection_tasks/page',
      deleteUrl: '/pipe-network/inspection_tasks',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      queryOneUrl: '/pipe-network/inspection_tasks',
      exportDataUrl: 'pipe-network/inspection_tasks/export',
      exportFileName: '任务管理数据表.xlsx',
      query: {
        status: '',
        patrolman: '',
        taskNumber: '',
        taskType: '',
        place: '',
        startTime: '',
        endTime: '',
        sysType: '巡检',
        predictStime: '',
        predictEtime: '',
        processingTime: '',
        taskName: '',
      },
      onChangets: [],
      onChangeht: [],

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
        sysType: '巡检',
      },
      statu: '',
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'manager/file/resources/upload',
      TaskList: [],
      eventTypeList: [],
      Uploadtime: [],
    }
  },
  filters: {
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  computed: {
    rules () {
      return {}
    },
  },
  created () {
    this.getTaskList()
    this.resetList()
  },
  methods: {
    moment,
    // resetList() {
    //   if (this.query.sysType) {
    //     let params = {
    //       sysType: this.query.sysType,
    //     }
    //     this.query = params
    //   } else {
    //     this.query = {}
    //   }
    //   this.pagination.current = 1
    //   this.selectedRows = []

    //   this.queryList()
    // },
    onChanget (value, dateString) {
      this.query.predictStime = dateString[0]
      this.query.predictEtime = dateString[1]
    },
    onChanges (value, dateString) {
      this.query.endTime = dateString[1]
      this.query.startTime = dateString[0]
    },
    // onChanget(value, dateString) {
    //   this.query.predictEtime = dateString
    // },
    handleMapOk (data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.locationInformation = data.point
      console.log(this.addOrUpdateForm.address)
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {

          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            this.selectedRows = []
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    resetList () {
      this.query = {
        status: this.statu,
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '巡检',
        processingTime: '',
        taskName: '',
      }
      this.pagination.current = 1
      this.onChangets = []
      this.Uploadtime = []
      this.selectedRows = []
      this.queryList()
    },
    callback (key) {
      console.log(key)
      this.statu = key
      this.selectedRows = []
      if (key == '全部') {
      } else {
      }
      this.queryList()
    },
    PublishTask () {
      this.$refs.TaskModal.edit()
    },
    editHandle (record) {
      console.log(123)
      this.$refs.TaskModal.edit(record.id)
    },
    goDetails (id) {
      this.$refs.DetailsModal.edit(id)
    },
    DispatchOrder () {
      if (this.selectedRows.length == 1) {
        this.$refs.OrderModal.edit(this.selectedRowsList[0])
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要派发工单的事件')
      } else {
        return this.$message.warn('只能选择一条要派发工单的事件')
      }
    },
    selectChange (value) {
      this.addOrUpdateForm.accessorys = `${value}`
    },
    getTaskList () {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {

        this.TaskList = data
      })
    },
    EndOnChange (date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange (date, dateString) {
      this.query.startTime = dateString
    },

    detailInfo (record) {
      this.detailForm = { ...record }
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel () { },
    onOk (value) { },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
